// extracted by mini-css-extract-plugin
module.exports = {"main":"ViewerSplit_main__21pKL"};